import React from 'react';
import { DownloadableTable } from '../../ui/styles/DownloadableTable'; // ajusta si tu ruta es otra

export const DownloadableProductTableUI = ({ products }) => {
    const currencyFmt = new Intl.NumberFormat('es-ES', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

    const percentFmt = new Intl.NumberFormat('es-ES', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

    const calcTotalPrice = (product) => {
        const qty = product.quantity || 0;
        const selling = product.sellingPrice || 0;
        const tax = product.tax || 0;

        const base = qty * selling;
        return base + (base * tax) / 100;
    };

    // Descuento en € por línea: (basePrice - sellingPrice) * quantity
    const calcDiscountEuros = (product) => {
        const qty = product.quantity || 0;
        const selling = product.sellingPrice || 0;

        // Si no viene basePrice, consideramos 0 descuento (evita NaN y “saltos”)
        const base = typeof product.basePrice === 'number' ? product.basePrice : selling;

        const perUnitDiscount = Math.max(0, base - selling);
        return perUnitDiscount * qty;
    };

    return (
        <DownloadableTable>
            <thead>
            <tr>
                <th>Ref.</th>
                <th className="desc">Descripción</th>
                <th className="center">Cantidad</th>
                <th className="num">Precio<br />Ud(s)</th>
                <th className="num">IVA (%)</th>
                <th className="num">Dto (€) </th>
                <th className="num">Total</th>
            </tr>
            </thead>

            <tbody>
            {products.map((product, index) => (
                <tr key={index}>
                    <td style={{ whiteSpace: 'nowrap' }}>{product.code}</td>
                    <td className="desc">{product.name ? product.name : 'N/A'}</td>
                    <td className="center">{product.quantity}</td>
                    <td className="num">{currencyFmt.format(product.sellingPrice || 0)}</td>
                    <td className="num">{percentFmt.format(product.tax || 0)} %</td>
                    <td className="num">{currencyFmt.format(calcDiscountEuros(product))}</td>
                    <td className="num">{currencyFmt.format(calcTotalPrice(product))}</td>
                </tr>
            ))}
            </tbody>
        </DownloadableTable>
    );
};
